import React, { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch (e) {
      // Expected on logged-out sessions (401). Only log unexpected errors.
      if (e?.response && e.response.status !== 401) {
        console.debug("auth.refresh failed:", e?.response?.status, e?.message);
      }
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password, ref) => {
    const { data } = await api.post("/auth/register", { name, email, password, ref: ref || undefined });
    setUser(data.user);
    try {
      const { clearStoredRef } = await import("../lib/refCapture");
      clearStoredRef();
    } catch (e) {
      console.debug("clearStoredRef import skipped:", e?.message || e);
    }
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.debug("Logout request failed:", e); }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export { formatApiErrorDetail };
